import { dateFromNow } from './dateUtils'

/**
 * @description Determines whether the user is online now
 * @param lastOnline, the time string of when the suer was the last online
 * @param listingPath, the path to the listing
 * @returns boolean the boolean that indicates whether the user is online
 */
export const isOnlineNow = (lastOnline: string, listingPath: string): boolean => {
  const MAX_TIME_DIFF = 15
  const upgradedNeededToSeeListing = listingPath === '/upgrade'
  const lastOnlineTime = new Date(lastOnline)
  const timeDiffMins = Math.abs(dateFromNow(lastOnlineTime).minutes)

  return !upgradedNeededToSeeListing && timeDiffMins < MAX_TIME_DIFF
}
